import { ProductTypeEnum } from '__generatedTypes__/globalTypes'
import { pluralize } from './pluralize'

const MEMBERSHIP_TYPE_LABEL = {
  [ProductTypeEnum.Free]: 'Free',
  [ProductTypeEnum.Premium]: 'Premium Membership',
  [ProductTypeEnum.PremiumMax]: 'Premium Membership Max',
  [ProductTypeEnum.Extension]: 'Extension',
}

type MembershipTitleInput = {
  type: ProductTypeEnum
  isSubscription: boolean
  duration: string
  deletedAt?: string | null
}

export const getMembershipTitle = (membership: MembershipTitleInput) => {
  const deletedWarning = membership.deletedAt ? ' - DELETED' : ''

  if (membership.type === ProductTypeEnum.Free) {
    return 'Free Membership' + deletedWarning
  }

  if (membership.isSubscription) {
    return `${membership.duration === '30' ? 'Monthly' : 'Yearly'} Premium Access` + deletedWarning
  }

  const membershipType = MEMBERSHIP_TYPE_LABEL[membership.type as keyof typeof MEMBERSHIP_TYPE_LABEL]

  return (
    `${membershipType} (${membership.duration}-${pluralize(Number(membership.duration), 'day', 'days')})` +
    deletedWarning
  )
}
